/* eslint-disable indent */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 *
 * GenerateReportModal
 *
 */

import React, {
  memo,
  useState,
  useRef,
  forwardRef,
  useEffect,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import moment from 'moment';
import {
  ModalContent,
  ModalHeader,
  Button,
  DateFilter,
  Dropdown,
  Conditional,
  Space,
  Checkbox,
  Text,
  DropdownItem,
  DropdownMenu,
  Icon,
  ShimmerTag,
  InputField,
  Popup,
  Cross,
} from '@cashfree-intl/coherent';
import {
  DEFAULT_DATE_OPTIONS,
  DATE_FILTER_RANGE_SIZE,
  DATE_FILTER_YEARLY_RANGE_SIZE,
  TRANSACTION_STATUS_CHECKBOX_OPTIONS,
  SBC_PAYMENTS_STATUS_CHECKBOX_OPTIONS,
  SBC_STATUS_CHECKBOX_OPTIONS,
  REPORT_DOWNLOAD_FORMAT_OPTIONS,
  TXT_DELIMITER_OPTIONS,
  SUCCESS,
} from 'utils/constants';

import FormikComponent from 'components/Formik';
import CustomIcon from 'components/CustomIcons';
import useClickOutside from 'utils/hooks';
import { getAnnualYears } from 'utils/common';
import { V2_EXPERIENCE_FLAG } from 'containers/v2/constants';
import { StyledChip, StyledChipsWrapper, StyledModal } from './styled';
import validate from './validation';
import {
  DATE_FORMAT_FOR_FILE_NAME,
  SETTLEMENTS,
  VENDOR_RECON,
  PAYMENT_LINK_TRANSACTIONS,
  TRANSACTIONS,
  SETTLEMENTS_RECON,
  SUBSCRIPTION_PAYMENTS,
  VENDOR_RECON_REPORT_FILE_NAME,
  VENDOR_RECON_REPORT_OPTIONS,
  SBC_REPORT_OPTIONS,
  VENDOR_ORDER_RECON_REPORT_OPTIONS,
  VENDOR_ORDER_RECON,
  VENDOR_ORDER_RECON_REPORT_FILE_NAME,
  FLOW_WISE_RECON,
  RISK_TRANSACTIONS,
  SELECT_ALL_STATUS,
  SELECT_ALL_SBC_PAYMENT_STATUS,
  SELECT_ALL_SBC_STATUS,
  SELECT_ALL_OTHER_FLAGS,
  SELECT_ALL_GATEWAYS,
} from './constants';
// import MultiDropdownProvider from './components/MultiDropdownProvider';
import MultiSelectDropdown from './components/MultiSelectDropdown';
import { useFetchMerchantRouteConfigs } from '../../containers/InsightsAI/hooks';

const getDateSuffix = dateRange =>
  `${moment(dateRange.range[0]).format(DATE_FORMAT_FOR_FILE_NAME)} - ${moment(
    dateRange.range[1],
  ).format(DATE_FORMAT_FOR_FILE_NAME)}`;

// eslint-disable-next-line react/prop-types
const trigger = forwardRef(({ open, text, ...props }, ref) => (
  <div ref={ref} {...props}>
    <Button
      type="button"
      icon={
        <Icon name={open ? 'chevron-up' : 'chevron-down'} className="ml-1" />
      }
      iconPosition="right"
    >
      {text}
    </Button>
  </div>
));

const arrangeReports = options => {
  const activeReports = [];
  const inactiveReports = [];

  options.forEach(obj => {
    if (obj.disabled) inactiveReports.push(obj);
    else activeReports.push(obj);
  });
  return activeReports.concat(inactiveReports);
};

const reportRange = reportType => {
  if (SBC_REPORT_OPTIONS.find(r => r.key === reportType.key) !== undefined) {
    return DATE_FILTER_YEARLY_RANGE_SIZE;
  }
  return DATE_FILTER_RANGE_SIZE;
};

// Add an event tracking when someone selects the report type from the dropdown

export function GenerateReportModal({
  closeModal,
  displayText,
  handleReportModalSubmit,
  hideDateFilter,
  modalData,
  reportOptions = [],
  disableDropdownSelections = false,
  merchantRoutesData = [],
  showCustomOptions = [],
}) {
  let initialFileName =
    modalData.fileName ||
    (reportOptions && reportOptions.length > 0
      ? reportOptions[0].fileName
      : '');

  if (initialFileName && !hideDateFilter) {
    initialFileName += ` ${moment(DEFAULT_DATE_OPTIONS[0].range[0]).format(
      DATE_FORMAT_FOR_FILE_NAME,
    )} - ${moment(DEFAULT_DATE_OPTIONS[0].range[1]).format(
      DATE_FORMAT_FOR_FILE_NAME,
    )}`;
  }
  const [dateRangeSelected, setDateRange] = useState(DEFAULT_DATE_OPTIONS[0]);
  const [selectedReportFormat, setSelectedReportFormat] = useState('CSV');
  const [selectedDelimiter, setSelectedDelimiter] = useState('');
  const [flowwiseOptions, setFlowwiseOptions] = useState([]);

  const {
    loading: fetchingMerchantRoutes,
    merchantRouteConfigs = [],
  } = useFetchMerchantRouteConfigs();

  const modalRef = useRef(null);

  useClickOutside(modalRef, closeModal);

  const { displayText: dateText, range } = dateRangeSelected;

  const dateDisplayText = `${dateText} (${moment(range[0]).format(
    'DD MMM, YYYY',
  )} - ${moment(range[1]).format('DD MMM, YYYY')})`;

  const handleReportFormatSelection = (e, data) => {
    setSelectedReportFormat(data.value);
    if (data.value !== 'TXT') {
      setSelectedDelimiter('');
    }
  };

  const handleDelimiterSelection = (e, data) => {
    setSelectedDelimiter(data.value);
  };

  useEffect(() => {
    if (merchantRoutesData.length) {
      const tempArray = [
        {
          key: 'ALL',
          text: 'All Payment Gateways',
          value: 'ALL',
          readOnly: false,
        },
      ];
      merchantRoutesData.forEach((m, index) => {
        const obj = {
          key: `${m.pg}-${index}`,
          text: m.pgName,
          value: m.pg,
          readOnly: !m.reconcilable,
        };
        tempArray.push(obj);
      });
      setFlowwiseOptions(tempArray);
    }
  }, [merchantRoutesData]);

  const flowwiseRoutes = useMemo(() => {
    if (fetchingMerchantRoutes) return [];
    return merchantRouteConfigs
      .map(m => ({
        key: m.merchantRouteId,
        text: m.name,
        value: m.merchantRouteId,
      }))
      .filter(obj => obj.text !== '');
  }, [fetchingMerchantRoutes]);

  const renderReportFormatDropdown = values => {
    // If the selected date range is FY, exclude XLSX
    const isFYSelected = dateRangeSelected?.displayText?.includes('FY');

    const allowedOptions = isFYSelected
      ? REPORT_DOWNLOAD_FORMAT_OPTIONS.filter(opt => opt.value !== 'XLSX')
      : REPORT_DOWNLOAD_FORMAT_OPTIONS;

    if (isFYSelected && selectedReportFormat === 'XLSX') {
      setSelectedReportFormat('CSV');
    }

    return (
      <div
        className={`file-format-option ${
          values.reportType?.key === FLOW_WISE_RECON ? 'mt-2' : ''
        }`}
      >
        <div className="label fnt-14 line-ht-16">File Format</div>
        <Dropdown
          placeholder="Select the option"
          options={allowedOptions}
          value={selectedReportFormat}
          onChange={handleReportFormatSelection}
          selection
          icon={<CustomIcon componentName="CHEVRONDOWN" />}
        />
      </div>
    );
  };

  const onSubmit = (values, actions) => {
    // eslint-disable-next-line no-shadow
    const {
      fileName,
      merchantOrderDataHeader,
      offerDataHeader,
      reportType,
      paymentLinkData,
      paymentFormData,
      vbaTransferData,
      vendorReconReportType = {},
      vendorOrderReconReportType = {},
      ...rest
    } = values;
    const updatedFileName = fileName.replace(' & ', ' %26 ');

    const obj = {
      reportType,
      fileName: updatedFileName.trim(),
      ...(reportType.key !== PAYMENT_LINK_TRANSACTIONS && {
        fileExtension: selectedReportFormat,
      }),
      ...(selectedReportFormat === 'TXT' && selectedDelimiter && {
        delimiter: selectedDelimiter,
      }),
    };

    if (reportType.key === TRANSACTIONS) {
      obj.status = Object.values(rest)
        .filter(
          val =>
            !!val &&
            Object.values(TRANSACTION_STATUS_CHECKBOX_OPTIONS).includes(val),
        )
        .join(',');
      obj.merchantRouteId = Object.values(rest)
        .reduce((result, val) => {
          if (val && typeof val === 'string' && val.startsWith('ROUTE_')) {
            result.push(val.replace('ROUTE_', '').trim());
          }
          return result;
        }, [])
        .join(',');
      if (merchantOrderDataHeader) obj.merchantOrderDataHeader = true;
      if (offerDataHeader) obj.offerDataHeader = true;
      if (paymentLinkData) obj.paymentLinkData = true;
      if (paymentFormData) obj.paymentFormData = true;
    }

    if (
      reportType.key === TRANSACTIONS ||
      reportType.key === SETTLEMENTS_RECON
    ) {
      if (vbaTransferData) obj.vbaTransferData = true;
    }

    if (
      [
        SETTLEMENTS_RECON,
        FLOW_WISE_RECON,
        'SETTLEMENTS_RECON_OFFLINE',
      ].includes(reportType.key)
    ) {
      if (offerDataHeader) obj.offerDataHeader = true;
      if (paymentLinkData) obj.paymentLinkData = true;
      if (paymentFormData) obj.paymentFormData = true;
    }

    if (reportType.key === FLOW_WISE_RECON) {
      const data = values.paymentGateway;
      let result = [];
      if (data.length) {
        result = data
          .filter(f => f.value !== 'ALL')
          .map(d => d.value)
          .join(',');
      }
      obj.pg = result;
    }

    if (reportType.key === SUBSCRIPTION_PAYMENTS) {
      const sbcPaymentStatus = [];
      if (!!values.SBCPaymentsInitialized) sbcPaymentStatus.push('INITIALIZED');
      if (!!values.SBCPaymentsCancelled) sbcPaymentStatus.push('CANCELLED');
      if (!!values.Success) sbcPaymentStatus.push(values.Success);
      if (!!values.Failed) sbcPaymentStatus.push(values.Failed);
      if (!!values.Pending) sbcPaymentStatus.push(values.Pending);
      if (sbcPaymentStatus.length) obj.paymentStatus = sbcPaymentStatus;
      const subStatus = [];
      if (!!values.Initialized) subStatus.push(values.Initialized);
      if (!!values['Bank Approval Pending'])
        subStatus.push(values['Bank Approval Pending']);
      if (!!values.Active) subStatus.push(values.Active);
      if (!!values.Cancelled) subStatus.push(values.Cancelled);
      if (!!values['On Hold']) subStatus.push(values['On Hold']);
      if (subStatus.length) obj.subStatus = subStatus;
    }

    if (reportType.key === RISK_TRANSACTIONS) obj.status = SUCCESS;

    const { value: vendorReconReportTypeValue } = vendorReconReportType;

    if (!hideDateFilter) obj.dateRangeSelected = { ...dateRangeSelected };

    if (vendorReconReportTypeValue === VENDOR_RECON && values.vendorId) {
      obj.vendorId = values.vendorId;
    } else if (
      (vendorReconReportTypeValue === SETTLEMENTS ||
        vendorReconReportTypeValue === 'SETTLEMENTS_OFFLINE') &&
      values.settlementId
    ) {
      obj.settlementId = values.settlementId;
    }

    if (
      vendorOrderReconReportType.value === VENDOR_ORDER_RECON &&
      values.orderId
    ) {
      obj.orderIds = values.orderId;
    }

    handleReportModalSubmit(obj, actions);
  };

  return (
    <StyledModal
      open
      className="common-modal-wrapper generate-report-modal"
      ref={modalRef}
      $maxWidth={reportOptions && reportOptions.length > 0 ? '728' : '560'}
    >
      <ModalHeader>
        <div>
          <div className="heading">Generate New Report</div>
        </div>
        <div className="close-modal" onClick={closeModal}>
          <CustomIcon componentName="CLOSE" />
        </div>
      </ModalHeader>
      <ModalContent>
        <div className="modal-content">
          <FormikComponent
            initialValues={{
              fileName: initialFileName || '',
              Success: TRANSACTION_STATUS_CHECKBOX_OPTIONS.Success,
              merchantOrderDataHeader: '',
              offerDataHeader: '',
              paymentLinkData: '',
              paymentFormData: '',
              vbaTransferData: '',
              vendorId: '',
              settlementId: '',
              orderId: '',
              merchantRouteId: [],
              vendorReconReportType: VENDOR_RECON_REPORT_OPTIONS[0],
              vendorOrderReconReportType: VENDOR_ORDER_RECON_REPORT_OPTIONS[0],
              reportType:
                reportOptions && reportOptions.length > 0
                  ? reportOptions[0]
                  : '',
            }}
            validate={validate}
            validateOnMount
            onSubmit={onSubmit}
          >
            {({
              values = {},
              handleFieldBlur,
              handleFieldChange,
              handleSubmit,
              errors,
              touched,
              setFieldValue,
              setFieldTouched,
              setFieldError,
              ...formikProps
            }) => {
              const disableField =
                !formikProps.isValidating && formikProps.isSubmitting;

              const onCrossClick = (name, selected) => () => {
                // console.log(name, selected);
                const data = values[name];
                let result = [];
                if (data.length > 0) {
                  if (selected.value === 'ALL') {
                    result = [];
                  } else {
                    result = data.filter(obj => obj.value !== selected.value);
                    result = result.filter(obj => obj.value !== 'ALL');
                  }

                  setFieldValue(name, result);
                }
              };
              const onDateRangeSelect = selectedRange => {
                if (selectedRange.range && selectedRange.range.length > 1) {
                  setDateRange(selectedRange);

                  const dateSuffix = getDateSuffix(selectedRange);

                  if (!hideDateFilter) {
                    let newFileName = '';
                    if (
                      values.vendorReconReportType &&
                      values.vendorReconReportType.value === VENDOR_RECON
                    )
                      newFileName = VENDOR_RECON_REPORT_FILE_NAME[VENDOR_RECON];
                    else if (values.reportType && values.reportType.fileName)
                      newFileName = values.reportType.fileName;
                    newFileName += ` ${dateSuffix}`;
                    setFieldValue('fileName', newFileName);
                  }
                }
              };

              const onStatusCheckboxChange = selectAllFieldName => (
                e,
                data,
              ) => {
                // if select all is selected then uncheck it
                if (!!values[selectAllFieldName]) {
                  setFieldValue([selectAllFieldName], false);
                }
                handleFieldChange(e, data);
              };

              const onGatewaysCheckboxChange = (e, data) => {
                if (data.value === SELECT_ALL_GATEWAYS.value) {
                  const allStatusObj = {};
                  Object.keys(flowwiseRoutes).forEach(key => {
                    allStatusObj[`ROUTE_${key}`] = data.checked
                      ? `ROUTE_${flowwiseRoutes[key].value}`
                      : '';
                  });
                  formikProps.setValues({
                    ...values,
                    ...allStatusObj,
                    [SELECT_ALL_GATEWAYS.value]: data.checked,
                  });
                } else {
                  handleFieldChange(e, data);
                }
              };

              const handleSelectAll = (options, fieldName) => (e, data) => {
                const allStatusObj = {};
                Object.keys(options).forEach(key => {
                  allStatusObj[key] = data.checked ? options[key] : '';
                });
                // setting the form values
                formikProps.setValues({
                  ...values,
                  ...allStatusObj,
                  [fieldName]: data.checked,
                });
              };

              const handleOtherFlagsSelectAll = (e, data) => {
                const allFlagsObj = {
                  offerDataHeader: data.checked,
                  paymentLinkData: data.checked,
                  paymentFormData: data.checked,
                };

                if (values.reportType.key === TRANSACTIONS) {
                  allFlagsObj.merchantOrderDataHeader = data.checked;
                }

                if (
                  values.reportType.key === TRANSACTIONS ||
                  values.reportType.key === SETTLEMENTS_RECON
                ) {
                  allFlagsObj.vbaTransferData = data.checked;
                }

                formikProps.setValues({
                  ...values,
                  ...allFlagsObj,
                  [data.value]: data.checked,
                });
              };

              const onDropdownItemClick = option => () => {
                const isFYSelected = dateRangeSelected?.displayText?.includes(
                  'FY',
                );
                const isFYAllowed =
                  showCustomOptions &&
                  showCustomOptions.length > 0 &&
                  showCustomOptions.includes(option.key);

                const shouldResetFY = isFYSelected && !isFYAllowed;

                if (shouldResetFY) {
                  setDateRange(DEFAULT_DATE_OPTIONS[0]);
                }

                setFieldValue('reportType', option);
                const dateSuffix = getDateSuffix(dateRangeSelected);
                setFieldValue('fileName', `${option.fileName} ${dateSuffix}`);
              };

              const isSettlementSpecificVendorReconSelected =
                values.vendorReconReportType &&
                values.vendorReconReportType.value === SETTLEMENTS;

              const isVendorOrderReconSelected =
                values.vendorOrderReconReportType &&
                values.vendorOrderReconReportType.value === VENDOR_ORDER_RECON;

              const showDateFilter =
                !hideDateFilter &&
                !isSettlementSpecificVendorReconSelected &&
                !isVendorOrderReconSelected;

              const onVendorReconReportChange = option => () => {
                const dateSuffix = `${moment(range[0]).format(
                  DATE_FORMAT_FOR_FILE_NAME,
                )} - ${moment(range[1]).format(DATE_FORMAT_FOR_FILE_NAME)}`;
                const fileName = VENDOR_RECON_REPORT_FILE_NAME[option.value];

                if (option.value === SETTLEMENTS) {
                  formikProps.setValues({
                    ...values,
                    vendorReconReportType: option,
                    fileName: `${fileName} ${
                      values.settlementId ? ` - ${values.settlementId}` : ''
                    }`,
                  });
                } else if (option.value === VENDOR_RECON) {
                  formikProps.setValues({
                    ...values,
                    vendorReconReportType: option,
                    fileName: `${fileName} ${dateSuffix}`,
                  });
                  if (errors.settlementId)
                    formikProps.setFieldError('settlementId', '');
                } else {
                  formikProps.setValues({
                    ...values,
                    vendorReconReportType: option,
                    fileName: `${modalData.fileName} ${dateSuffix}`,
                  });
                  if (errors.settlementId)
                    formikProps.setFieldError('settlementId', '');
                }
              };

              const onVendorOrderReconReportChange = option => () => {
                const dateSuffix = `${moment(range[0]).format(
                  DATE_FORMAT_FOR_FILE_NAME,
                )} - ${moment(range[1]).format(DATE_FORMAT_FOR_FILE_NAME)}`;
                const fileName =
                  VENDOR_ORDER_RECON_REPORT_FILE_NAME[option.value];

                if (option.value === VENDOR_ORDER_RECON) {
                  formikProps.setValues({
                    ...values,
                    vendorOrderReconReportType: option,
                    fileName: `${fileName} ${
                      values.orderId ? ` - ${values.orderId}` : ''
                    }`,
                  });
                } else {
                  formikProps.setValues({
                    ...values,
                    vendorOrderReconReportType: option,
                    fileName: `${fileName} ${dateSuffix}`,
                  });
                  if (errors.orderId) formikProps.setFieldError('orderId', '');
                }
              };

              const renderVendorReconFields = () => (
                <Space alignItems="baseline" gap={3}>
                  <div className="select-field  date-range-select">
                    <Text varint="b14" color="bodyLight">
                      Vendor Recon Report Type
                    </Text>
                    <Dropdown
                      className="vendor-recon-report-type-dropdown"
                      button
                      placeholder="Select the report type"
                      icon={<CustomIcon componentName="CHEVRONDOWN" />}
                      text={
                        values.vendorReconReportType
                          ? values.vendorReconReportType.text
                          : null
                      }
                    >
                      <DropdownMenu>
                        {VENDOR_RECON_REPORT_OPTIONS.map(option => (
                          <DropdownItem
                            key={option.key}
                            onClick={onVendorReconReportChange(option)}
                            selected={
                              values.vendorReconReportType &&
                              values.vendorReconReportType.value ===
                                option.value
                            }
                            data-event-name="Dropdown_Item"
                            data-ignore-inner-text="true"
                            data-event-properties={JSON.stringify({
                              ...V2_EXPERIENCE_FLAG,
                              dropdown_id: option.key,
                            })}
                          >
                            <Space gap={1} direction="column">
                              <Text strong>{option.text}</Text>
                              <Text
                                variant="b12"
                                color="bodyLight"
                                style={{ whiteSpace: 'pre-wrap' }}
                              >
                                {option.description}
                              </Text>
                            </Space>
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <Conditional
                    if={
                      values.vendorReconReportType &&
                      values.vendorReconReportType.value === VENDOR_RECON
                    }
                  >
                    <InputField
                      className="vendor-id-input"
                      label="Vendor ID"
                      id="vendorId"
                      name="vendorId"
                      errors={errors}
                      touched={touched}
                      value={values.vendorId}
                      disabled={disableField}
                      onChange={handleFieldChange}
                      onBlur={handleFieldBlur}
                    />
                  </Conditional>
                  <Conditional
                    if={
                      values.vendorReconReportType &&
                      values.vendorReconReportType.value === SETTLEMENTS
                    }
                  >
                    <InputField
                      className="settlement-id-input"
                      label="Settlement ID"
                      id="settlementId"
                      name="settlementId"
                      errors={errors}
                      touched={touched}
                      value={values.settlementId}
                      disabled={disableField}
                      onChange={handleFieldChange}
                      onBlur={handleFieldBlur}
                    />
                  </Conditional>
                </Space>
              );

              const renderVendorOrderReconFields = () => (
                <Space alignItems="baseline" gap={3}>
                  <div className="select-field  date-range-select">
                    <Text varint="b14" color="bodyLight">
                      Vendor Order Recon Report Type
                    </Text>
                    <Dropdown
                      className="vendor-recon-report-type-dropdown"
                      button
                      placeholder="Select the report type"
                      icon={<CustomIcon componentName="CHEVRONDOWN" />}
                      text={
                        values.vendorOrderReconReportType
                          ? values.vendorOrderReconReportType.text
                          : null
                      }
                    >
                      <DropdownMenu>
                        {VENDOR_ORDER_RECON_REPORT_OPTIONS.map(option => (
                          <DropdownItem
                            key={option.key}
                            onClick={onVendorOrderReconReportChange(option)}
                            selected={
                              values.vendorOrderReconReportType &&
                              values.vendorOrderReconReportType.value ===
                                option.value
                            }
                            data-event-name="Dropdown_Item"
                            data-ignore-inner-text="true"
                            data-event-properties={JSON.stringify({
                              ...V2_EXPERIENCE_FLAG,
                              dropdown_id: option.key,
                            })}
                          >
                            <Space gap={1} direction="column">
                              <Text strong>{option.text}</Text>
                            </Space>
                          </DropdownItem>
                        ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <Conditional
                    if={
                      values.vendorOrderReconReportType &&
                      values.vendorOrderReconReportType.value ===
                        VENDOR_ORDER_RECON
                    }
                  >
                    {/* update the id, name and values key name here */}
                    <InputField
                      className="settlement-id-input"
                      label="Order ID"
                      id="orderId"
                      name="orderId"
                      errors={errors}
                      touched={touched}
                      value={values.orderId}
                      disabled={disableField}
                      onChange={handleFieldChange}
                      onBlur={handleFieldBlur}
                    />
                  </Conditional>
                </Space>
              );

              return (
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <Space
                    alignItems="center"
                    justifyContent="space-between"
                    // className="mb-3"
                    gap={3}
                  >
                    <Conditional if={reportOptions && reportOptions.length > 0}>
                      <Space
                        direction="column"
                        gap={1}
                        className="report-type-dropdown mb-3"
                      >
                        <Text varint="b14" color="bodyLight">
                          Report Type
                        </Text>
                        <Dropdown
                          className="modal-dropdown"
                          selection
                          placeholder="Report Type"
                          text={
                            values.reportType ? values.reportType.text : null
                          }
                          disabled={disableDropdownSelections}
                          icon={<CustomIcon componentName="CHEVRONDOWN" />}
                        >
                          <DropdownMenu>
                            {arrangeReports(reportOptions).map(option => (
                              <DropdownItem
                                key={option.key}
                                onClick={onDropdownItemClick(option)}
                                selected={
                                  !!values.reportType &&
                                  option.value === values.reportType.value
                                }
                                disabled={option.disabled}
                                data-event-name="Dropdown_Item"
                                data-ignore-inner-text="true"
                                data-event-properties={JSON.stringify({
                                  ...V2_EXPERIENCE_FLAG,
                                  dropdown_id: option.key,
                                })}
                              >
                                <Space gap={1} direction="column">
                                  <Space gap={1} alignItems="center">
                                    <Text strong>{option.text}</Text>
                                    <Conditional if={option.showNewLabel}>
                                      <ShimmerTag>New</ShimmerTag>
                                    </Conditional>
                                  </Space>
                                  <Text
                                    variant="b12"
                                    color="bodyLight"
                                    style={{ whiteSpace: 'pre-wrap' }}
                                  >
                                    {option.description}
                                  </Text>
                                </Space>
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </Space>
                    </Conditional>
                    <Conditional if={showDateFilter}>
                      <div className="select-field  date-range-select mb-3">
                        <Text varint="b14" color="bodyLight">
                          Date Range
                        </Text>
                        <DateFilter
                          value={{
                            ...dateRangeSelected,
                            displayText: dateDisplayText,
                          }}
                          rangeSize={reportRange(values.reportType)}
                          options={DEFAULT_DATE_OPTIONS}
                          // options={DATE_OPTIONS_FOR_REPORTS}
                          onSelect={onDateRangeSelect}
                          trigger={trigger}
                          // custom={false}
                          custom
                          annualYearOptions={
                            showCustomOptions &&
                            values.reportType &&
                            showCustomOptions.includes(values.reportType.key)
                              ? getAnnualYears()
                              : []
                          }
                        />
                      </div>
                    </Conditional>
                  </Space>
                  <Conditional
                    if={
                      values.reportType &&
                      values.reportType.key === VENDOR_RECON
                    }
                  >
                    {renderVendorReconFields()}
                  </Conditional>
                  <Conditional
                    if={
                      values.reportType &&
                      values.reportType.key === VENDOR_ORDER_RECON
                    }
                  >
                    {renderVendorOrderReconFields()}
                  </Conditional>
                  <Space
                    alignItems="flex-start"
                    className="file-name-wrapper mb-3"
                    gap={1}
                    wrap="wrap"
                  >
                    {values.reportType &&
                      values.reportType.key === FLOW_WISE_RECON && (
                        <div>
                          <Text color="bodyLight" className="mb-1">
                            Payment Gateway
                          </Text>
                          <MultiSelectDropdown
                            options={flowwiseOptions}
                            name="paymentGateway"
                            placeholder="Select Payment Gateway"
                            value={values.paymentGateway}
                            setFieldValue={(name, data) => {
                              setFieldValue(name, data);
                              if (
                                values.paymentGateway &&
                                values.paymentGateway.length > 0
                              )
                                setFieldValue('paymentMethod', []);
                            }}
                            setFieldTouched={setFieldTouched}
                            setFieldError={setFieldError}
                          />
                          <Conditional if={errors.paymentGateway}>
                            <Text variant="b12" color="danger" className="mt-1">
                              {errors.paymentGateway}
                            </Text>
                          </Conditional>
                        </div>
                      )}
                    <InputField
                      label="File Name"
                      id="fileName"
                      name="fileName"
                      className={`${
                        values.reportType &&
                        values.reportType.key === FLOW_WISE_RECON
                          ? 'filename-input-wrapper'
                          : ''
                      }`}
                      errors={errors}
                      touched={touched}
                      value={values.fileName}
                      disabled={disableField}
                      allowedValues="wordWithoutCommaAndBracket"
                      onChange={(e, data) => {
                        setFieldTouched('fileName', true);
                        handleFieldChange(e, data);
                      }}
                      onBlur={handleFieldBlur}
                    />
                    <Conditional
                      if={
                        displayText === SETTLEMENTS ||
                        (values.reportType &&
                          values.reportType.key !== PAYMENT_LINK_TRANSACTIONS)
                      }
                    >
                      <Space gap={1} alignItems="flex-start">
                        <div
                          className={`dropdown-field ${
                            values.reportType &&
                            values.reportType.key === FLOW_WISE_RECON
                              ? 'dropdown-field-flowwise'
                              : ''
                          }`}
                        >
                          <>
                            <Conditional
                              if={
                                values.reportType &&
                                values.reportType.key === FLOW_WISE_RECON &&
                                values.paymentGateway?.length > 0
                              }
                            >
                              <StyledChipsWrapper
                                gap={1}
                                alignItems="center"
                                wrap
                                className="mb-2"
                              >
                                {values.paymentGateway?.slice(0, 3).map(obj => (
                                  <StyledChip
                                    key={obj.text}
                                    alignItems="center"
                                    gap={1}
                                  >
                                    <Text variant="b12">{obj.text}</Text>
                                    <Cross
                                      size="sm"
                                      onClick={onCrossClick(
                                        'paymentGateway',
                                        obj,
                                      )}
                                    />
                                  </StyledChip>
                                ))}
                                {values.paymentGateway?.slice(3)?.length > 0 && (
                                  <Popup
                                    content={() =>
                                      values.paymentGateway?.slice(3).map(obj => (
                                        <Text
                                          key={obj.text}
                                          variant="b12"
                                          color="bodyLight"
                                        >
                                          {obj.text}
                                        </Text>
                                      ))
                                    }
                                    hoverable
                                    position="right"
                                    trigger={
                                      <Text
                                        variant="b14"
                                        color="primary"
                                        className="pointer"
                                      >
                                        +{values.paymentGateway?.slice(3)?.length}{' '}
                                        More
                                      </Text>
                                    }
                                  />
                                )}
                              </StyledChipsWrapper>
                            </Conditional>
                            {renderReportFormatDropdown(values)}
                          </>
                        </div>
                        {selectedReportFormat === 'TXT' && (
                          <div className="dropdown-field">
                            <div className="label fnt-14 line-ht-16">Delimiter</div>
                            <Dropdown
                              placeholder="Select delimiter"
                              options={TXT_DELIMITER_OPTIONS}
                              value={selectedDelimiter}
                              onChange={handleDelimiterSelection}
                              selection
                              icon={<CustomIcon componentName="CHEVRONDOWN" />}
                            />
                          </div>
                        )}
                      </Space>
                    </Conditional>
                  </Space>
                  <Conditional
                    if={
                      values.reportType &&
                      values.reportType.key === TRANSACTIONS
                    }
                  >
                    <div>
                      <Text variant="b14" color="bodyLight">
                        Status
                      </Text>
                      <Checkbox
                        key={SELECT_ALL_STATUS.key}
                        value={SELECT_ALL_STATUS.value}
                        name={SELECT_ALL_STATUS.key}
                        label={SELECT_ALL_STATUS.label}
                        checked={!!values[SELECT_ALL_STATUS.value]}
                        onChange={handleSelectAll(
                          TRANSACTION_STATUS_CHECKBOX_OPTIONS,
                          SELECT_ALL_STATUS.value,
                        )}
                        className="form-checkbox"
                      />
                      {Object.keys(TRANSACTION_STATUS_CHECKBOX_OPTIONS).map(
                        keyName => (
                          <Checkbox
                            key={keyName}
                            value={TRANSACTION_STATUS_CHECKBOX_OPTIONS[keyName]}
                            name={keyName}
                            label={keyName}
                            checked={!!values[keyName]}
                            onChange={onStatusCheckboxChange(
                              SELECT_ALL_STATUS.value,
                            )}
                            className="form-checkbox"
                          />
                        ),
                      )}
                      <Conditional if={errors.status}>
                        <div className="error-message checkbox-err">
                          {errors.status}
                        </div>
                      </Conditional>
                    </div>
                  </Conditional>
                  <Conditional
                    if={
                      values?.reportType?.key === TRANSACTIONS &&
                      flowwiseRoutes?.length > 0
                    }
                  >
                    <div>
                      <Text variant="b14" color="bodyLight">
                        Gateways
                      </Text>
                      <Checkbox
                        key={SELECT_ALL_GATEWAYS.key}
                        value={SELECT_ALL_GATEWAYS.value}
                        name={SELECT_ALL_GATEWAYS.key}
                        label={SELECT_ALL_GATEWAYS.label}
                        checked={!!values[SELECT_ALL_GATEWAYS.value]}
                        onChange={onGatewaysCheckboxChange}
                        className="form-checkbox"
                      />
                      {flowwiseRoutes.map(gateway => (
                        <Checkbox
                          key={`ROUTE_${gateway.value}`}
                          value={`ROUTE_${gateway.value}`}
                          name={`ROUTE_${gateway.value}`}
                          label={gateway.text}
                          checked={!!values[`ROUTE_${gateway.value}`]}
                          onChange={onGatewaysCheckboxChange}
                          className="form-checkbox"
                        />
                      ))}
                    </div>
                  </Conditional>
                  <Conditional
                    if={
                      values.reportType &&
                      [
                        SETTLEMENTS_RECON,
                        TRANSACTIONS,
                        FLOW_WISE_RECON,
                      ].includes(values.reportType.key)
                    }
                  >
                    <div className="mt-2">
                      <Text variant="b14" color="bodyLight" className="mb-1">
                        Other Flags
                      </Text>
                      <Conditional if={values.reportType.key === TRANSACTIONS}>
                        <Checkbox
                          key="merchantOrderDataHeader"
                          name="merchantOrderDataHeader"
                          label="Merchant Data"
                          checked={!!values.merchantOrderDataHeader}
                          onChange={onStatusCheckboxChange(
                            SELECT_ALL_OTHER_FLAGS.value,
                          )}
                          className="order-data-checkbox form-checkbox"
                        />
                      </Conditional>
                      <Conditional
                        if={
                          values.reportType.key === TRANSACTIONS ||
                          values.reportType.key === SETTLEMENTS_RECON
                        }
                      >
                        <Checkbox
                          key="vbaTransferData"
                          name="vbaTransferData"
                          label="VBA Transfer Data"
                          checked={!!values.vbaTransferData}
                          onChange={onStatusCheckboxChange(
                            SELECT_ALL_OTHER_FLAGS.value,
                          )}
                          className="order-data-checkbox form-checkbox"
                        />
                      </Conditional>
                      <Checkbox
                        key="offerDataHeader"
                        name="offerDataHeader"
                        label="Offers / No Cost EMI Data"
                        checked={!!values.offerDataHeader}
                        onChange={onStatusCheckboxChange(
                          SELECT_ALL_OTHER_FLAGS.value,
                        )}
                        className="order-data-checkbox form-checkbox"
                      />
                      <Checkbox
                        key="paymentLinkData"
                        name="paymentLinkData"
                        label="Payment Link Data"
                        checked={!!values.paymentLinkData}
                        onChange={onStatusCheckboxChange(
                          SELECT_ALL_OTHER_FLAGS.value,
                        )}
                        className="order-data-checkbox form-checkbox"
                      />
                      <Checkbox
                        key="paymentFormData"
                        name="paymentFormData"
                        label="Payment Form Data"
                        checked={!!values.paymentFormData}
                        onChange={onStatusCheckboxChange(
                          SELECT_ALL_OTHER_FLAGS.value,
                        )}
                        className="order-data-checkbox form-checkbox"
                      />
                      <Checkbox
                        key={SELECT_ALL_OTHER_FLAGS.key}
                        value={SELECT_ALL_OTHER_FLAGS.value}
                        name={SELECT_ALL_OTHER_FLAGS.key}
                        label={SELECT_ALL_OTHER_FLAGS.label}
                        checked={!!values[SELECT_ALL_OTHER_FLAGS.value]}
                        onChange={handleOtherFlagsSelectAll}
                        className="order-data-checkbox form-checkbox"
                      />
                    </div>
                  </Conditional>
                  <Conditional
                    if={
                      values.reportType &&
                      values.reportType.key === SUBSCRIPTION_PAYMENTS
                    }
                  >
                    <div>
                      <Text variant="b14" color="bodyLight" className="mb-2">
                        Sbc Payment Status
                      </Text>
                      {Object.keys(SBC_PAYMENTS_STATUS_CHECKBOX_OPTIONS).map(
                        keyName => (
                          <Checkbox
                            key={keyName}
                            value={
                              SBC_PAYMENTS_STATUS_CHECKBOX_OPTIONS[keyName]
                            }
                            name={keyName}
                            label={(() => {
                              if (keyName === 'SBCPaymentsInitialized')
                                return 'Initialized';
                              if (keyName === 'SBCPaymentsCancelled')
                                return 'Cancelled';
                              return keyName;
                            })()}
                            checked={!!values[keyName]}
                            onChange={onStatusCheckboxChange(
                              SELECT_ALL_SBC_PAYMENT_STATUS.value,
                            )}
                            className="form-checkbox"
                          />
                        ),
                      )}
                      <Checkbox
                        key={SELECT_ALL_SBC_PAYMENT_STATUS.key}
                        value={SELECT_ALL_SBC_PAYMENT_STATUS.value}
                        name={SELECT_ALL_SBC_PAYMENT_STATUS.key}
                        label={SELECT_ALL_SBC_PAYMENT_STATUS.label}
                        checked={!!values[SELECT_ALL_SBC_PAYMENT_STATUS.value]}
                        onChange={handleSelectAll(
                          SBC_PAYMENTS_STATUS_CHECKBOX_OPTIONS,
                          SELECT_ALL_SBC_PAYMENT_STATUS.value,
                        )}
                      />
                      <Conditional if={errors.status}>
                        <div className="error-message checkbox-err">
                          {errors.status}
                        </div>
                      </Conditional>
                    </div>
                    <div>
                      <Text color="bodyLight" variant="b14" className="mb-2">
                        Subscription Status
                      </Text>
                      {Object.keys(SBC_STATUS_CHECKBOX_OPTIONS).map(keyName => (
                        <Checkbox
                          key={keyName}
                          value={SBC_STATUS_CHECKBOX_OPTIONS[keyName]}
                          name={keyName}
                          label={keyName}
                          checked={!!values[keyName]}
                          onChange={onStatusCheckboxChange(
                            SELECT_ALL_SBC_STATUS.value,
                          )}
                          className="form-checkbox"
                        />
                      ))}
                      <Checkbox
                        key={SELECT_ALL_SBC_STATUS.key}
                        value={SELECT_ALL_SBC_STATUS.value}
                        name={SELECT_ALL_SBC_STATUS.key}
                        label={SELECT_ALL_SBC_STATUS.label}
                        checked={!!values[SELECT_ALL_SBC_STATUS.value]}
                        onChange={handleSelectAll(
                          SBC_STATUS_CHECKBOX_OPTIONS,
                          SELECT_ALL_SBC_STATUS.value,
                        )}
                      />
                      <Conditional if={errors.status}>
                        <div className="error-message checkbox-err">
                          {errors.status}
                        </div>
                      </Conditional>
                    </div>
                  </Conditional>
                  <div className="cta-wrapper">
                    <Button
                      type="button"
                      className="link"
                      link
                      onClick={closeModal}
                      data-event-name="Form_GenerateReportModal_Button_Cancel"
                    >
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      primary
                      disabled={!formikProps.isValid || disableField}
                      data-event-name="Primary_Button_GenerateReport"
                    >
                      Generate Report
                    </Button>
                  </div>
                </form>
              );
            }}
          </FormikComponent>
        </div>
      </ModalContent>
    </StyledModal>
  );
}

GenerateReportModal.propTypes = {
  handleReportModalSubmit: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  displayText: PropTypes.string,
  hideDateFilter: PropTypes.bool,
  modalData: PropTypes.object,
  reportOptions: PropTypes.array,
  disableDropdownSelections: PropTypes.bool,
  merchantRoutesData: PropTypes.array,
  showCustomOptions: PropTypes.arrayOf(PropTypes.string),
};

export default memo(GenerateReportModal);
